/**
 * Session Management Utilities
 *
 * Handles session-based order tracking for anonymous users
 * Part of Enhanced Order Architecture Phase 3
 */

/**
 * Generate a unique session ID for anonymous order tracking
 */
export const generateSessionId = (): string => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 8);
  return `sess_${timestamp}_${randomPart}`;
};

/**
 * Get or create session ID for current browser session
 */
export const getOrCreateSessionId = (): string => {
  const SESSION_KEY = 'innolek_session_id';

  // Try to get existing session ID
  let sessionId = window.localStorage.getItem(SESSION_KEY);

  // Create new session ID if none exists
  if (!sessionId) {
    sessionId = generateSessionId();
    window.localStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
};

/**
 * Clear session ID (when user completes order or resets)
 */
export const clearSessionId = (): void => {
  window.localStorage.removeItem('innolek_session_id');
};

/**
 * Get current session ID without creating new one
 */
export const getCurrentSessionId = (): string | null => {
  return window.localStorage.getItem('innolek_session_id');
};

/**
 * Check if user has an active session
 */
export const hasActiveSession = (): boolean => {
  return getCurrentSessionId() !== null;
};
